import $FormJS from "../../utils/form";
import formcontent from "../../form_content/index.vue";
export default {
  components: {
    formcontent
  },
  name: "YnFormDsh",
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      searchItem: {},
      formSet: {},
      formInfo: {},
      list: [],
      tableColumns: [],

      showTable: true,
      pageOpt: [10, 20, 50, 100],
      total: 0,
      currentPageSize: 10,
      currentPage: 1,
      dateDay: [
        {
          title: "上午",
          key: "am",
        },
        {
          title: "下午",
          key: "pm",
        },
      ],

      showModal: false,

      mark: "",
      dataId: "",
      flowId: "",
      action: 0,
      serId: 0,

      showContent: false,
      lookForm: {},
    };
  },
  props: {
    formId: {
      type: String,
      default() {
        return "";
      },
    },
  },
  watch: {
    formId(val) {
      if (this.formId && this.formId.length > 0) {
        this.getFormInfo();
      }
    },
  },
  computed: {

    currentPaths() {
      return this.$store.state.app.currentPaths[
        this.$store.state.app.currentPaths.length - 1
      ];
    },
    userInfo() {
      return this.$store.state.user;
    },
  },
  methods: {
    look(index) {
      this.lookForm = JSON.parse(JSON.stringify(this.list[index]));
      console.log(`lookForm:${JSON.stringify(this.lookForm)}`);
      this.showContent = true;
    },
    showExam(index, action) {
      var model = this.list[index];
      this.dataId = model.serId;

      var flows = model.flows;

      console.log(`flows:${JSON.stringify(flows)}`);
      this.flowId = "";
      this.serId = 0;
      if (flows && flows.length > 0) {
        this.flowId = flows[flows.length - 1].flowId;
        this.serId = flows[flows.length - 1].serId;
      }
      this.mark = "";
      this.action = action;

      this.showModal = true;
    },
    docompelete() {
      this.getData();
      this.showContent = false;
    },


    setShowStyle(type) {
      if (type == 1) {
        this.showTable = true;
        this.currentPageSize = 10;
        this.pageOpt = [10, 20, 50, 100];
      } else {
        this.showTable = false;
        this.currentPageSize = 8;
        this.pageOpt = [8, 16, 32, 80];
      }
      this.getData();
    },
    formTitle(item) {
      return $FormJS.formTitle(item, this.formSet);
    },
    formContent(item) {
      return $FormJS.formContent(item, this.formSet);
    },
    formStatus(status, action) {
      return $FormJS.formStatus(status, action);
    },
    formStatusType(status, action) {
      return $FormJS.formStatusType(status, action);
    },
    dateFormatter(time) {
      return $FormJS.dateFormatter(time);
    },
    pageSizeChange(pageSize) {
      this.currentPageSize = pageSize;
      this.getData();
    },
    pageChange(page) {
      this.currentPage = page;
      this.getData();
    },

    getFormInfo() {
      this.$axios({
        baseURL: this.config.OA,
        url: `form/info/id/${this.formId}`,
        method: "GET",
      }).then((res) => {
        if (res.code == 200) {
          this.formInfo = res.data;

          this.getSet();
        }
      });
    },
    getSet() {
      this.$axios
        .request({
          baseURL: this.config.OA,
          url: `form/info/set/${this.formId}`,
          method: "GET",
        })
        .then((res) => {
          if (res.code == 200) {
            this.formSet = res.data;
            this.setTabColumn();
            this.getData();
          }
        });
    },
    getData() {
      this.$axios({
        baseURL: this.config.OA,
        url: `form/info/data/type/${this.formId}`,
        method: "POST",
        data: {
          type: 1,
          action: 1,
          plat: "pc",
          page: this.currentPage,
          pageSize: this.currentPageSize,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          this.list = res.data.list;
        }
      });
    },
    setTabColumn() {
      var column = [];

      if (this.formSet.titleSet && this.formSet.titleSet.formItems) {
        //标题设置
        this.formInfo.formList.forEach((a) => {
          var info = this.formSet.titleSet.formItems.filter((x) => {
            return a.set.setId && a.set.setId == x;
          });

          if (info != null && info.length > 0) {
            if (a.set.control == "datepicker" && a.set.type == "range") {
              column.push({
                title: a.set.title,
                key: a.set.setId,
                slot: "datepicker_start",
              });
              column.push({
                title: a.set.title2,
                key: a.set.setId,
                slot: "datepicker_end",
              });
              if (a.set.isDuration) {
                column.push({
                  title: a.set.timeLongTitle,
                  key: a.set.setId,
                  slot: "datepicker_timelong",
                });
              }
            } else {
              if (column.length == 0) {
                column.push({
                  title: a.set.title,
                  key: a.set.setId,
                  slot: "content",
                  fixed: "left",
                  tooltip: true,
                  maxWidth: 500,
                });
              } else {
                column.push({
                  title: a.set.title,
                  key: a.set.setId,
                  slot: "content",
                  tooltip: true,
                  maxWidth: 500,
                });
              }
            }
          }
        });
      }

      column.push({
        title: "添加时间",
        key: "createTime",
      });
      if (this.formInfo.type == 1) {
        column.push({
          title: "状态",
          key: "status",
          slot: "status",
          fixed: "right",
          width: 150,
        });
      }
      column.push({
        title: "操作",
        key: "action",
        slot: "action",
        fixed: "right",
        width: 200,
      });

      this.tableColumns = column;
    },

    getDatePickerRang(info, column, type) {
      var list = info.formList.filter((a) => {
        return a.set.setId == column.key;
      });

      var model = null;
      if (list && list.length > 0) {
        model = list[0];
      }
      if (model == null) return "";

      if (model.set.control == "datepicker" && model.set.type == "range") {
        var value = JSON.parse(model.set.value);
        if (type == 1) {
          var title = model.set.start;
          if (model.set.isTil) {
            title += ` ${this.dateDay[model.set.startIndex].title}`;
          }
          return title;
        }
        if (type == 2) {
          var title = model.set.end;
          if (model.set.isTil) {
            title += ` ${this.dateDay[model.set.endIndex].title}`;
          }
          return title;
        }
        if (type == 3) {
          var unit = "（小时）";
          if (model.set.unit == "date") {
            unit = "（天）";
          }
          return `${value}${unit}`
        }

        return "";
      }
    },

    getInfo(info, column, index) {
      var list = info.formList.filter((a) => {
        return a.set.setId == column.key;
      });

      var model = null;
      if (list && list.length > 0) {
        model = list[0];
      }
      if (model == null) return "";

      var title2 = model.set.value;
      if (model.set.control == 'hq_wz' || model.set.control == "wz_sq") {
        var value = JSON.parse(model.set.value);
        var title = "";

        value.forEach(a => {
          title += `物品：${a.title},申请数量：${a.count}\n`;
        })
        title2 = title;

      } else if (model.set.control == "class_stu" || model.set.control == "xb_grade" || model.set.control == "xb_sub") {
        var value = JSON.parse(model.set.value);
        title2 = value.title;
      } else if (model.set.control == "xb_teacher") {
        var value = JSON.parse(model.set.value);
        title2 = value.title
      } else if (model.set.control == "xb_place") {
        var value = JSON.parse(model.set.value);
        title2 = value.title
      } else if (model.set.control == "user_baseinfo") {
        var value = JSON.parse(model.set.value);
        title2 = value.name;
        if (value.type == "student") {
          title2 += `/${value.className}`;
        }
      } else if (model.set.control == "school_week") {
        var value = JSON.parse(model.set.value);
        title2 = value.title;
      } else if (
        model.set.control == "datepicker" &&
        model.set.type == "range"
      ) {
        var value = JSON.parse(model.set.value);
        title2 = `${model.set.start}-${model.set.end}`;
        var unit = "（小时）";
        if (model.set.unit == "date") {
          unit = "（天）";
        }
        if (model.set.isDuration) {
          title2 += `，${model.set.timeLongTitle}：${value}${unit}`;
        }
      } else {
        title2 = JSON.parse(model.set.value);
      }

      return title2;
    },

    getStatusTitle(status, action) {
      var title = "";
      if (status == 0) {
        switch (action) {
          case 1:
            title = "待审核";
            break;
          case 4:
            title = "待办理";
            break;
          default:
            title = "已完成";
            break;
        }
      } else {
        switch (action) {
          case 2:
            title = "已通过";
            break;
          case 3:
            title = "已拒绝";
            break;
          case 6:
            title = "已拒绝";
            break;
          default:
            title = "已完成";
            break;
        }
      }
      return title;
    },
    getStatuColor(status, action) {
      var color = "";
      if (status == 0) {
        switch (action) {
          case 1:
            color = "warning";
            break;
          case 4:
            color = "warning";
            break;
          default:
            color = "success";
            break;
        }
      } else {
        switch (action) {
          case 2:
            color = "success";
            break;
          case 3:
            color = "error";
            break;
          case 6:
            color = "error";
            break;
          default:
            color = "success";
            break;
        }
      }
      return color;
    },
  },
  created() {
    this.getFormInfo();
  },
};
